import { Tag, TagLeftIcon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the primary tag
 * 
 * @param {Object} props - The props of the component
 * @returns The primary tag
 */
const PrimaryTag = ({ children, icon, ...props }) => (
  <Tag gap={1} variant={"primary"} {...props}>
    {icon && <TagLeftIcon as={icon} boxSize={"15px"} />}
    {children}
  </Tag>
);

export default React.memo(PrimaryTag);
